import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Paper, CircularProgress, ListItemIcon, IconButton, useMediaQuery, DialogTitle, DialogContent, Dialog, Typography,
} from '@mui/material';
import {defaultVariables} from "../../../../../config";
import axios from "axios";
import RayaField from "../../../../components/elements/fields/RayaField";
import InputAdornment from "@mui/material/InputAdornment";
import {ArrowLeft, Search, X} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {theme} from "../../../../../config/design/theme";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CartWidget from "../../shops/components/CartWidget";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {connect} from "trim-redux";
import Grid from "@mui/material/Grid2";
import Title from "../../../../components/elements/Title";
import SingleCardProduct from "../../products/components/SingleCardProduct";

const VendorSearchField = ({vendor_id,searchResult,setSearchQuery,classes}) => {
    const { t } = useTranslation();

    const [query, setQuery] = useState('');
    const [result, setResult] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigation = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(false);

    let debounceTimeout = null;
    const config = {
        headers: {
            Accept: 'application/json',
        },
    };

    // Fetch suggestions from the server
    const fetchResults = async (value) => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${defaultVariables.url}/search/vendor/${vendor_id}/${encodeURIComponent(value)}`,config);
            searchResult(response.data);
            setResult(response.data);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle input change with debounce
    const handleInputChange = (event) => {
        const value = event.target.value;
        setQuery(value);
        setSearchQuery(value);

        clearTimeout(debounceTimeout);

        if (value) {
            debounceTimeout = setTimeout(() => {
                fetchResults(value);
            }, 300); // Adjust debounce delay as needed
        } else {
            searchResult([]);
            setResult([]);
        }
    };
    const clearSearch= () =>{
        searchResult([]);
        setResult([]);
        setQuery("");
        setSearchQuery("");
    }
    return (
        <div className="vendor-search-holder">
            {
                !!isMobile ?
                    <>
                        <IconButton onClick={() => setOpen(true)}>
                            <Search className="lucide-icon" />
                        </IconButton>
                        <Dialog
                            fullScreen
                            open={open}
                            className="vendor-search-dialog"
                            onClose={() => setOpen(false)}
                            TransitionProps={{
                                onEntered: () => {
                                    // Focus the input field after the dialog has fully transitioned in
                                    document.getElementById('search-field').focus();
                                }
                            }}
                        >
                            <DialogTitle style={{display:"flex",alignItems:'center',justifyContent:"space-between"}}>
                                <IconButton
                                    color="text"
                                    onClick={() => setOpen(false)}
                                >
                                    <ArrowLeft className="lucide-large"/>
                                </IconButton>
                                <div className="main-search-holder" style={{width:"100%"}}>
                                    <RayaField
                                        id="search-field"
                                        value={query}

                                        onChange={handleInputChange}
                                        autoComplete="off"
                                        fullWidth
                                        placeholder={t('searchInVendor')}
                                        slotProps={{
                                            input: {
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {
                                                            isLoading ?
                                                                <CircularProgress size={14} color="text"/>
                                                                :
                                                                <>
                                                                    {
                                                                        !!query ?
                                                                            <IconButton onClick={() => clearSearch()}>
                                                                                <X className="lucide-icon-primary" />
                                                                            </IconButton>
                                                                            :
                                                                            <IconButton>
                                                                                <Search className="lucide-icon-primary" />
                                                                            </IconButton>
                                                                    }
                                                                </>

                                                        }
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </div>

                            </DialogTitle>
                            <DialogContent>
                                {
                                    (!!result.length || !!query) &&
                                    <Grid className="menu-holder-grid" item size={12} >
                                        <Title color="text" component="h2" align="left" className="menu-title">{t('searchResultFor')} "{query}"</Title>
                                        <Grid container spacing={2} className="search-results-vendor">
                                            <>
                                                {
                                                    !!result.length ?
                                                        <>
                                                            {result.map((product, index) => (
                                                                <Grid item size={{ xs: 12 ,md:6}} key={index}>
                                                                    <SingleCardProduct product={product} addtocart />
                                                                </Grid>
                                                            ))}
                                                        </>
                                                        :
                                                        <Grid item size={{ xs: 12 }} >
                                                            <Typography>{t('noResultsFound')}</Typography>
                                                        </Grid>
                                                }

                                            </>

                                        </Grid>
                                    </Grid>
                                }
                            </DialogContent>

                        </Dialog>
                    </>
                    :
                    <div className="main-search-holder">
                        <RayaField
                            value={query}
                            onChange={handleInputChange}
                            autoComplete="off"
                            fullWidth
                            placeholder={t('searchInVendor')}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {
                                                isLoading ?
                                                    <CircularProgress size={14} color="text"/>
                                                    :
                                                    <>
                                                        {
                                                            !!query ?
                                                                <IconButton onClick={() => clearSearch()}>
                                                                    <X className="lucide-icon-primary" />
                                                                </IconButton>
                                                                :
                                                                <IconButton>
                                                                    <Search className="lucide-icon-primary" />
                                                                </IconButton>
                                                        }
                                                    </>

                                            }
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    </div>
            }

        </div>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(VendorSearchField));
